const getTargetValue = (e: any) => e.target.value;

export default getTargetValue;
